exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".version---2lbp5{position:fixed;right:0;bottom:0;max-width:100%;padding:.5em;background:#eee;color:#666;font-family:Arial,Helvetica,sans-serif;font-size:1em;opacity:.9;z-index:9999}.version---2lbp5 span{color:#aaa}", ""]);

// exports
exports.locals = {
	"version": "version---2lbp5"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1&modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/sass-resources-loader/lib/loader.js!./src/entry/views/version/version.scss
// module id = 1023
// module chunks = 0